export const MAP_CENTER_OFFSET_Y = 100;
export const DEFAULT_ZOOM = 16;
export const DEFAULT_SEARCH_AREA_INDEX = 0;
export const DEFAULT_SEATS = 4;
export const MAXIMUM_SEATS = 99;
export const SCROLL_DEBOUNCE_TIME = 48;
export const DEFAULT_RADIUS = 1000;

// @TODO サービスの利用可能時間を、firebase から取得する。 #251
// https://github.com/toreta/skipr-sp/issues/251
export const SEARCH_END_TIME = 17400;
export const SEARCH_START_TIME = 21600;

export const SITE_URL = 'https://www.toretanow.app';
export const INQUIRY_URL =
  'https://docs.google.com/forms/d/e/1FAIpQLSfjmzdjgxnPnYCMHtcCKiUWflw9f-fYBS0mR6yF730tzeM4DQ/viewform?entry.599592381=';
export const TERM_URL = 'https://www.toretanow.app/pdf/term.pdf';
export const PRIVACY_URL = 'https://www.toretanow.app/pdf/privacy.pdf';
export const USAGE_URL = 'https://teachme.jp/16816/f/roomgNIMKJSO';
export const FAQ_URL = 'https://www.toretanow.app/faq/';
export const CONTACT_URL = 'https://www.toretanow.app/contact/';
export const CORPORATE_URL = 'https://corp.toreta.in/';
export const CONTACT_STORE_URL = 'https://www.toretanow.app/contact/store/';
export const NEWS_URL = 'https://www.toretanow.app/news/';
export const SMS_HELP_URL = 'https://www.toretanow.app/help/';

export const INITIALIZE_AGREEMENT_VERSION = 1;
